
const splitArrayEvenly = (arrayList, numGroups) => {
    arrayList = arrayList.slice();
    let result = [];
    while (arrayList.length) {
        result.push(arrayList.splice(0, Math.ceil(arrayList.length / numGroups--)));
    }
    return result;
};

export {
    splitArrayEvenly
};